import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { msUrlServer } from '../global_constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MsSectorService {

  sectorsSubject:Subject<any>;
  newSectorSubject:Subject<any>;
  updateSectorSubject:Subject<any>;
  deleteSectorSubject:Subject<any>;
  
  baseUrl = msUrlServer.concat("/v2/sector");


  constructor(private httpClient:HttpClient) {
    this.sectorsSubject = new Subject();
    this.newSectorSubject = new Subject();
    this.updateSectorSubject = new Subject();
    this.deleteSectorSubject = new Subject();
  }

  getSectors(token : any){
    this.sectorsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + token );
    this.httpClient.get(this.baseUrl,{headers: header}).subscribe((response: any) => {
      this.sectorsSubject.next(response);
      this.sectorsSubject.complete();
    },error => {
      console.log(error);
    });
  }

  addSector(token:any ,sector: any){
    this.newSectorSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + token );
    this.httpClient.post(this.baseUrl, sector, {headers: header}).subscribe((response: any) => {
      this.newSectorSubject.next(response);
      this.newSectorSubject.complete();
    },error => {
      console.log(error);
    });
  }

  updateSector(token : any, sector :any){
    this.updateSectorSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + token );
    this.httpClient.patch(this.baseUrl, sector, {headers: header}).subscribe((response: any) => {
      this.updateSectorSubject.next(response);
      this.updateSectorSubject.complete();
    },error => {
      console.log(error);
    });
  }

  deleteSector(token : any, id : any){
    this.deleteSectorSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + token );
    this.httpClient.delete(`${this.baseUrl}/${id}`,{headers: header}).subscribe((response: any) => {
      this.deleteSectorSubject.next(response);
      this.deleteSectorSubject.complete();
    },error => {
      console.log(error);
    });
  }
  
  getSector(token: any, id: any): Observable<any> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + token);
    return this.httpClient.get(`${this.baseUrl}/${id}`, { headers: header })
      .pipe(
        map((response: any) => response)
      );
  }
}
